class VantaProduct extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
    this.form = this.querySelector('form');
    this.idField = this.form.querySelector('[name=id]');
    this.submit = this.querySelector('[data-submit]');
    this.mobileSubmit = this.querySelector('[data-mobile-submit]');
    this.buyNow = this.querySelector('[data-buy-now]');
    this.error = this.querySelector('[data-error-message]');
    this.dialog = this.querySelector('dialog');
    this.querySelectorAll('[name=vanta_color]').forEach(input => input.addEventListener('change', () => this.select(input.value)));
    this.querySelectorAll('[data-thumb]').forEach(button => button.addEventListener('click', () => this.showImage(button.dataset.thumb)));
    this.querySelectorAll('[data-media-id]').forEach(button => button.addEventListener('click', () => {
      const source = button.querySelector('img');
      const image = this.dialog.querySelector('img');
      image.src = source.currentSrc || source.src;
      image.alt = source.alt;
      this.dialog.showModal();
    }));
    this.dialog.querySelector('[data-close]').addEventListener('click', () => this.dialog.close());
    this.dialog.addEventListener('click', event => {if (event.target === this.dialog) this.dialog.close();});
    let startX = 0;
    const stage = this.querySelector('.v-gallery-stage');
    stage.addEventListener('touchstart', e => {startX = e.changedTouches[0].clientX;}, {passive:true});
    stage.addEventListener('touchend', e => {
      const distance = e.changedTouches[0].clientX - startX;
      if (Math.abs(distance) < 50) return;
      const thumbs = [...this.querySelectorAll('[data-thumb]')].filter(t => !t.hidden);
      const current = thumbs.findIndex(t => t.getAttribute('aria-current') === 'true');
      if (thumbs.length) this.showImage(thumbs[(current + (distance < 0 ? 1 : -1) + thumbs.length) % thumbs.length].dataset.thumb);
    }, {passive:true});
    this.form.addEventListener('submit', e => this.add(e));
    const colorParam = new URL(location.href).searchParams.get('color');
    const colorVariant = this.variants.find(v => v.color.toLowerCase().replace(/\s+/g, '-') === colorParam);
    this.select(colorVariant?.id || this.idField.value, false);
    window.addEventListener('popstate', () => {
      if (this.dataset.updateUrl === 'true') this.select(new URL(location.href).searchParams.get('variant') || this.variants[0].id, false);
    });
  }
  select(id, update = true) {
    const variant = this.variants.find(v => String(v.id) === String(id));
    if (!variant) return;
    this.idField.value = variant.id;
    this.querySelectorAll('[name=vanta_color]').forEach(i => {i.checked = i.value === String(variant.id);});
    this.querySelector('[data-price]').textContent = variant.price;
    this.submit.disabled = !variant.available;
    if (this.buyNow) this.buyNow.disabled = !variant.available;
    this.submit.textContent = variant.available ? this.dataset.add : this.dataset.sold;
    if (this.mobileSubmit) {
      this.mobileSubmit.disabled = !variant.available;
      this.mobileSubmit.textContent = this.submit.textContent;
      this.querySelector('[data-dock-price]').textContent = variant.price;
      const swatch = this.querySelector('[name=vanta_color]:checked');
      this.querySelector('[data-dock-color]').textContent = swatch?.closest('label')?.textContent.trim() || variant.color;
    }
    this.querySelector('[data-availability]').textContent = variant.available ? this.dataset.available : this.dataset.sold;
    this.querySelector('[data-payment]').hidden = !variant.available;
    const quantity = this.form.querySelector('[name=quantity]');
    quantity.min = variant.min; quantity.step = variant.step;
    if (variant.max) quantity.max = variant.max; else quantity.removeAttribute('max');
    quantity.value = variant.min;
    const thumbs = [...this.querySelectorAll('[data-thumb]')];
    const hasGroups = thumbs.some(t => this.variants.some(v => v.color === t.dataset.group));
    thumbs.forEach(t => { t.hidden = hasGroups && t.dataset.group !== variant.color && this.variants.some(v => v.color === t.dataset.group); });
    const first = thumbs.find(t => !t.hidden && t.dataset.thumb === String(variant.image)) || thumbs.find(t => !t.hidden);
    if (first) this.showImage(first.dataset.thumb);
    if (update && this.dataset.updateUrl === 'true') {
      const url = new URL(location.href); url.searchParams.set('variant', variant.id); history.replaceState({}, '', url);
    }
    this.error.hidden = true;
  }
  showImage(id) {
    this.querySelectorAll('[data-media-id]').forEach(image => {image.hidden = image.dataset.mediaId !== String(id);});
    this.querySelectorAll('[data-thumb]').forEach(thumb => thumb.setAttribute('aria-current', String(thumb.dataset.thumb === String(id))));
  }
  async add(event) {
    event.preventDefault();
    const buyNow = event.submitter?.hasAttribute('data-buy-now');
    if (this.submit.disabled) return;
    this.submit.disabled = true; if (this.buyNow) this.buyNow.disabled = true; if (this.mobileSubmit) this.mobileSubmit.disabled = true; this.submit.setAttribute('aria-busy','true'); this.error.hidden = true;
    const drawer = document.querySelector('cart-drawer');
    const data = new FormData(this.form);
    data.delete('vanta_color');
    if (drawer) {data.set('sections', drawer.getSectionsToRender().map(s => s.id).join(','));data.set('sections_url',location.pathname);drawer.setActiveElement(this.submit);}
    try {
      const response = await fetch(window.routes.cart_add_url.replace(/\.js$/, '') + '.js', {method:'POST',headers:{'X-Requested-With':'XMLHttpRequest','Accept':'application/json'},body:data});
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || this.dataset.error);
      if (buyNow) {location.assign((window.Shopify?.routes?.root || '/') + 'checkout'); return;}
      if (drawer) {drawer.classList.remove('is-empty');drawer.renderContents(result);} else {location.href = window.routes.cart_url;}
    } catch(error) {this.error.textContent = error.message || this.dataset.error;this.error.hidden = false;}
    finally {this.submit.disabled = !this.variants.find(v => String(v.id) === this.idField.value)?.available;this.submit.removeAttribute('aria-busy');if (this.mobileSubmit) this.mobileSubmit.disabled = this.submit.disabled;if (this.buyNow) this.buyNow.disabled = this.submit.disabled;}
  }
}
if (!customElements.get('vanta-product')) customElements.define('vanta-product',VantaProduct);
// Shopify's native localization form preserves the cart cookie; include the selected variant in its return path.
document.querySelectorAll('form[action*="/localization"]').forEach(form => form.addEventListener('submit', () => {
  let input = form.querySelector('[name=return_to]');
  if (!input) {input=document.createElement('input');input.type='hidden';input.name='return_to';form.append(input);}
  input.value = location.pathname + location.search;
}));
class VantaDemo extends HTMLElement {
  connectedCallback() {
    if (this.ready) return; this.ready = true;
    this.dialog = this.querySelector('dialog');
    this.querySelectorAll('[name=vanta_demo_color]').forEach(input => input.addEventListener('change', () => this.select(input.value)));
    document.querySelectorAll('[data-demo-color]').forEach(link => link.addEventListener('click', () => this.select(link.dataset.demoColor)));
    this.querySelectorAll('[data-demo-thumb]').forEach(thumb => thumb.addEventListener('click', () => {
      const gallery = thumb.closest('[data-demo-gallery]');
      gallery.querySelectorAll('[data-demo-image]').forEach(image => {image.hidden = image.dataset.demoImage !== thumb.dataset.demoThumb;});
      gallery.querySelectorAll('[data-demo-thumb]').forEach(t => t.setAttribute('aria-current', String(t === thumb)));
    }));
    this.querySelectorAll('[data-demo-image]').forEach(button => button.addEventListener('click', () => {
      const source = button.querySelector('img'); const target = this.dialog.querySelector('img');
      target.src = source.currentSrc || source.src; target.alt = source.alt; this.dialog.showModal();
    }));
    const initialColor = new URL(location.href).searchParams.get('color');
    if (['black','teal-green','stone-grey'].includes(initialColor)) this.select(initialColor);
    this.querySelector('[data-demo-close]').addEventListener('click', () => this.dialog.close());
    this.dialog.addEventListener('click',event => {if(event.target === this.dialog) this.dialog.close();});
  }
  select(color) {
    this.querySelectorAll('[data-demo-gallery]').forEach(gallery => {gallery.hidden = gallery.dataset.demoGallery !== color;});
    this.querySelectorAll('[name=vanta_demo_color]').forEach(input => {input.checked = input.value === color;});
  }
}
if (!customElements.get('vanta-demo')) customElements.define('vanta-demo',VantaDemo);
